import LaunchComponent from 'components/marketingSite/launch/LaunchComponent';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { config } from 'utils/config';

const LaunchLandingPage: React.FC = () => {
  const { t } = useI18n('launch-landing');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <Head>
        <title>{t('page_title')}</title>
      </Head>
      <LaunchComponent />
    </>
  );
};

export default LaunchLandingPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'launch-landing'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
